
import Modal from 'react-bootstrap/Modal';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";


function CustomModal({showModal,onClose }) {


  return (
    <>
      <Modal className='custom-modal'
        show={showModal}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton/>
        <Modal.Body>
          <div className="">
            <div className="icon mb-2">
              <IoMdCheckmarkCircleOutline size={96} />
            </div>
            <h2>Thank you!</h2>
            <p>Your details have been saved successfully.</p>
          </div>
        </Modal.Body>
        </Modal>
    </>
  );
}

export default CustomModal;